import { cn } from "@/lib/utils";

// Minimal, serious shield mark — not a neon/hacker glyph.
export function ShieldMark({ className, size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden>
      <path d="M16 2.5 5 6.8v8.1c0 6.9 4.6 11.9 11 14.6 6.4-2.7 11-7.7 11-14.6V6.8L16 2.5Z"
        fill="url(#sxg)" stroke="#2563EB" strokeWidth="1.1" strokeLinejoin="round" />
      <path d="M16 9.5v13M16 9.5c-2.6 1.6-4.4 1.9-6.2 1.9M16 9.5c2.6 1.6 4.4 1.9 6.2 1.9"
        stroke="#93C5FD" strokeWidth="1.3" strokeLinecap="round" opacity="0.9" />
      <defs>
        <linearGradient id="sxg" x1="5" y1="2.5" x2="27" y2="29.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1E293B" /><stop offset="1" stopColor="#0B1220" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Wordmark({ className, markSize = 26, text = true }) {
  return (
    <span className={cn("flex items-center gap-2.5", className)}>
      <ShieldMark size={markSize} />
      {text && (
        <span className="font-display text-lg font-extrabold tracking-tight text-slate-50">
          Shield<span className="text-blue-500">X</span>
        </span>
      )}
    </span>
  );
}
